(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2577,7382],{

/***/ 17080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);

var VideoDuration = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
            children: data === null || data === void 0 ? void 0 : data.videoDuration
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoDuration);


/***/ }),

/***/ 61730:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);



var AdHeader = function(props) {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
    // console.log('SDK', window?.AdsterSDK);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (AdHeader);


/***/ }),

/***/ 77382:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


var CategoriesLinks = function(param) {
    var categories = param.categories;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: categories && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 ? (categories === null || categories === void 0 ? void 0 : categories.length) > 1 && ((ref = categories[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.title) === null || ref1 === void 0 ? void 0 : ref1.includes("آخر الأخبار")) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/category/" + ((ref2 = categories[1]) === null || ref2 === void 0 ? void 0 : ref2.id) + "/" + ((ref3 = categories[1]) === null || ref3 === void 0 ? void 0 : ref3.title),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                "aria-label": "Go to 56",
                children: (ref4 = categories[1]) === null || ref4 === void 0 ? void 0 : ref4.title
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
            href: "/category/" + ((ref5 = categories[0]) === null || ref5 === void 0 ? void 0 : ref5.id) + "/" + ((ref6 = categories[0]) === null || ref6 === void 0 ? void 0 : ref6.title),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                href: "#",
                "aria-label": "Go to 57",
                children: (ref7 = categories[0]) === null || ref7 === void 0 ? void 0 : ref7.title
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CategoriesLinks);


/***/ }),

/***/ 50139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61310);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_Requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19061);
/* harmony import */ var _HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17080);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13009);
/* harmony import */ var apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42155);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50501);
/* harmony import */ var apps_frontend_services_Util__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(80368);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(81192);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(63201);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_13__);







// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper';








var HorizontalEpisodesSlider = function(param) {
    var episodes = param.episodes;
    var navigationPrevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationNextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "newsSliderText newsSlider2Text video_newsSlider_wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "TileBar scrollbarHeader heading_border",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "float-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            styles: "yellowTitle",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                children: "أحدث الحلقات"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliderArrows text-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-prev",
                                                ref: navigationPrevRef,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-next",
                                                ref: navigationNextRef,
                                                children: "Next"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "clearfix"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_7__/* .Swiper */ .tq, {
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    dir: "rtl",
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    breakpoints: {
                        // '1800': { slidesPerView: 3 },
                        "1024": {
                            slidesPerView: 4
                        },
                        "992": {
                            slidesPerView: 4
                        },
                        "575": {
                            slidesPerView: 3
                        },
                        "375": {
                            slidesPerView: 1.5
                        },
                        "320": {
                            slidesPerView: 1.5
                        }
                    },
                    pagination: false,
                    modules: [
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_,
                        apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_7__/* .Pagination */ .tl
                    ],
                    className: "mySwiper",
                    children: (episodes === null || episodes === void 0 ? void 0 : episodes.length) > 0 && episodes.map(function(episode, index) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(apps_frontend_components_SwiperClient_SwiperClient__WEBPACK_IMPORTED_MODULE_7__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "slider-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "NewsBox ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/episode/".concat((episode === null || episode === void 0 ? void 0 : episode.id) + "/" + (0,apps_frontend_services_Util__WEBPACK_IMPORTED_MODULE_14__/* .getSlugOrTitleWithDashes */ .aU)(episode === null || episode === void 0 ? void 0 : episode.title, episode === null || episode === void 0 ? void 0 : (ref = episode.seDetails) === null || ref === void 0 ? void 0 : ref.slugLine)),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "#",
                                                "aria-label": "Go to 75",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "newsImage",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                            showThumbnail: true,
                                                            className: "img-fluid",
                                                            src: (episode === null || episode === void 0 ? void 0 : (ref1 = episode.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url) ? episode === null || episode === void 0 ? void 0 : (ref2 = episode.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.url : (episode === null || episode === void 0 ? void 0 : (ref3 = episode.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path) ? _services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .baseUrlAdmin */ .s$ + (episode === null || episode === void 0 ? void 0 : (ref4 = episode.thumbnail) === null || ref4 === void 0 ? void 0 : ref4.path) : _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "PlayTime",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_5__["default"], {
                                                                    data: episode === null || episode === void 0 ? void 0 : episode.video
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                    className: "PlayButton-featured_50 PlayButton-base ",
                                                                    "data-type": "play",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "PlayButton-flyout",
                                                                            children: "شاهد الآن"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                            className: "icon-play-triangle PlayButton-icon",
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                                className: "fa play_medium"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "newscontent",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/episode/".concat((episode === null || episode === void 0 ? void 0 : episode.id) + "/" + (0,apps_frontend_services_Util__WEBPACK_IMPORTED_MODULE_14__/* .getSlugOrTitleWithDashes */ .aU)(episode === null || episode === void 0 ? void 0 : episode.title, episode === null || episode === void 0 ? void 0 : (ref5 = episode.seDetails) === null || ref5 === void 0 ? void 0 : ref5.slugLine)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "#",
                                                        "aria-label": episode === null || episode === void 0 ? void 0 : episode.title,
                                                        children: episode && (episode === null || episode === void 0 ? void 0 : episode.title)
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, index)
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalEpisodesSlider);


/***/ }),

/***/ 20398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57506);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76453);
/* harmony import */ var _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61310);
/* harmony import */ var _services_GetData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17004);
/* harmony import */ var _services_Requests__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19061);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(17080);
/* harmony import */ var _services_ResponseMapping__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(28427);
/* harmony import */ var _CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(77382);
/* harmony import */ var _TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4526);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(13009);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50501);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(81192);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63201);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_17__);




swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_
]);















var NewsFooter2SliderWithColoredBackGround = function(param) {
    var title = param.title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), exclusiveVideosNewsList = ref[0], setExclusiveVideosNewsList = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_services_GetData__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("".concat(_services_Requests__WEBPACK_IMPORTED_MODULE_6__/* .requests.exclusiveVideosNews */ .E7.exclusiveVideosNews, "&limit=10&pageNo=1"), {}, "get", false).then(function(res) {
            var newsResult = res.data && res.data.length ? res.data : [];
            newsResult = (0,_services_ResponseMapping__WEBPACK_IMPORTED_MODULE_18__/* .handleElkAndDbResponse */ .hb)(newsResult);
            setExclusiveVideosNewsList(newsResult);
        }).catch(function(err) {
            console.warn(err);
        });
    }, []);
    var navigationPrevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationNextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "newsSliderText newsSlider2Text",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "row",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-sm-7",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "float-end",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                    styles: "TitleBar",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        children: title
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-sm-5",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "sliderArrows text-start pt-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "slider-arrow arrow-prev",
                                        ref: navigationPrevRef,
                                        children: "Previous"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        className: "slider-arrow arrow-next",
                                        ref: navigationNextRef,
                                        children: "Next"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    dir: "rtl",
                    slidesPerView: 2.5,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    breakpoints: {
                        "1024": {
                            slidesPerView: 2.5
                        },
                        "992": {
                            slidesPerView: 1.5
                        },
                        "575": {
                            slidesPerView: 1.5
                        },
                        "375": {
                            slidesPerView: 1.5
                        },
                        "320": {
                            slidesPerView: 1.5
                        }
                    },
                    pagination: false,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
                    ],
                    className: "mySwiper",
                    children: exclusiveVideosNewsList.map(function(news, index) {
                        var ref, ref1, ref2, ref3;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "slider-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "NewsBox ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                            href: "/".concat(news === null || news === void 0 ? void 0 : news.routePath),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "newsImage",
                                                children: [
                                                    (news === null || news === void 0 ? void 0 : (ref = news.thumbnail) === null || ref === void 0 ? void 0 : ref.url) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        showThumbnail: true,
                                                        className: "img-fluid",
                                                        src: news === null || news === void 0 ? void 0 : (ref1 = news.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url
                                                    }) : (news === null || news === void 0 ? void 0 : (ref2 = news.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.path) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        showThumbnail: true,
                                                        className: "img-fluid",
                                                        src: _services_Requests__WEBPACK_IMPORTED_MODULE_6__/* .baseUrlAdmin */ .s$ + (news === null || news === void 0 ? void 0 : (ref3 = news.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path)
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                        showThumbnail: true,
                                                        className: "img-fluid",
                                                        src: _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "PlayTime",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                                                data: news === null || news === void 0 ? void 0 : news.video
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "PlayButton-featured_50 PlayButton-base ",
                                                                "data-type": "play",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "PlayButton-flyout",
                                                                        children: "شاهد الآن"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        className: "icon-play-triangle PlayButton-icon",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fa play_medium"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "newscontent",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_7___default()), {
                                                        href: "/".concat(news === null || news === void 0 ? void 0 : news.routePath),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "#",
                                                            "aria-label": "Go to 97",
                                                            children: news === null || news === void 0 ? void 0 : news.title
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CategoriesLinks_CategoriesLinks__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                            categories: news && (news === null || news === void 0 ? void 0 : news.categories)
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TimeAgoCustom_TimeAgoArabicFormat__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                                date: news === null || news === void 0 ? void 0 : news.createdAt
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NewsFooter2SliderWithColoredBackGround);


/***/ }),

/***/ 96250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61310);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39097);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _services_Requests__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19061);
/* harmony import */ var _services_GetData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17004);
/* harmony import */ var _HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17080);
/* harmony import */ var _Thumbnail__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13009);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(57506);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(76453);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50501);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81192);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63201);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_15__);
















var HorizontalProgramsSlider = function(param) {
    var title = param.title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]), programs = ref[0], setPrograms = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_services_GetData__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("".concat(_services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .requests.programs */ .E7.programs, "?limit=20&pageNo=1"), {}, "get", false).then(function(res) {
            var ref, ref1;
            setPrograms(res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.programs);
        }).catch(function(err) {
            console.warn(err);
        });
    }, []);
    var navigationPrevRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationNextRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "newsSliderText newsSlider2Text video_newsSlider_wrap",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "TileBar scrollbarHeader heading_border",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "float-end",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                            styles: "TitleBar",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "yellowTitle",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                    children: title
                                                })
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "sliderArrows text-start",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-prev",
                                                ref: navigationPrevRef,
                                                children: "Previous"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                className: "slider-arrow arrow-next",
                                                ref: navigationNextRef,
                                                children: "Next"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "clearfix"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .Swiper */ .tq, {
                    navigation: {
                        prevEl: navigationPrevRef.current,
                        nextEl: navigationNextRef.current
                    },
                    dir: "rtl",
                    slidesPerView: 4,
                    spaceBetween: 20,
                    slidesPerGroup: 1,
                    breakpoints: {
                        // '1800': { slidesPerView: 3 },
                        "1024": {
                            slidesPerView: 4
                        },
                        "992": {
                            slidesPerView: 4
                        },
                        "575": {
                            slidesPerView: 3
                        },
                        "375": {
                            slidesPerView: 1.5
                        },
                        "320": {
                            slidesPerView: 1.5
                        }
                    },
                    pagination: false,
                    modules: [
                        swiper__WEBPACK_IMPORTED_MODULE_9__/* .Navigation */ .W_,
                        swiper__WEBPACK_IMPORTED_MODULE_9__/* .Pagination */ .tl
                    ],
                    className: "mySwiper",
                    children: // show episodes
                    (programs === null || programs === void 0 ? void 0 : programs.length) > 0 && programs.map(function(program, index) {
                        var ref, ref1, ref2, ref3;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_8__/* .SwiperSlide */ .o5, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "slider-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "NewsBox ",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                            href: "/program/".concat(program.id + "/" + program.title),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "newsImage",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: "#",
                                                    "aria-label": "Go to 105",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Thumbnail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                            showThumbnail: true,
                                                            className: "img-fluid",
                                                            src: (program === null || program === void 0 ? void 0 : (ref = program.thumbnail) === null || ref === void 0 ? void 0 : ref.url) ? program === null || program === void 0 ? void 0 : (ref1 = program.thumbnail) === null || ref1 === void 0 ? void 0 : ref1.url : (program === null || program === void 0 ? void 0 : (ref2 = program.thumbnail) === null || ref2 === void 0 ? void 0 : ref2.path) ? _services_Requests__WEBPACK_IMPORTED_MODULE_4__/* .fileUrl */ ._h + (program === null || program === void 0 ? void 0 : (ref3 = program.thumbnail) === null || ref3 === void 0 ? void 0 : ref3.path) : _styles_images_cnbc_default_image_webp__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_HelperComponents_VideoDuration__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                                            data: program === null || program === void 0 ? void 0 : program.video
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "newscontent",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/program/".concat(program.id + "/" + (program === null || program === void 0 ? void 0 : program.title)),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "#",
                                                        "aria-label": "Go to 106",
                                                        children: program && (program === null || program === void 0 ? void 0 : program.title)
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            }, index)
                        }, index);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HorizontalProgramsSlider);


/***/ }),

/***/ 42155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W_": function() { return /* reexport safe */ swiper__WEBPACK_IMPORTED_MODULE_0__.W_; },
/* harmony export */   "o5": function() { return /* reexport safe */ swiper_react__WEBPACK_IMPORTED_MODULE_1__.o5; },
/* harmony export */   "tl": function() { return /* reexport safe */ swiper__WEBPACK_IMPORTED_MODULE_0__.tl; },
/* harmony export */   "tq": function() { return /* reexport safe */ swiper_react__WEBPACK_IMPORTED_MODULE_1__.tq; }
/* harmony export */ });
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76453);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57506);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84988);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36968);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68522);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_4__);
"use client";


// IMPORT SWIPER CSS ONCE HERE



// Register modules ONCE
swiper__WEBPACK_IMPORTED_MODULE_0__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_0__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_0__/* .Pagination */ .tl
]);



/***/ }),

/***/ 63201:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 81192:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

}]);